import { render, staticRenderFns } from "./MailMagazineUnsubscribe.vue?vue&type=template&id=9e065310&scoped=true&lang=pug&"
import script from "./MailMagazineUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./MailMagazineUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./MailMagazineUnsubscribe.vue?vue&type=style&index=0&id=9e065310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e065310",
  null
  
)

export default component.exports